<script>
import api from '@/api'
import { alertSuccess } from '@/helpers/swal'

export default {
  data() {
    return {
      pagetitle: 'Categories',
      category: {
        categoryName: '',
        categoryDescription: '',
      },
      errors: {
        categoryName: '',
        categoryDescription: '',
      },
      saveBtnDisabled: false,
    }
  },
  components: {},
  async mounted() {
    // In case of edit role
    const categoryId = this.$route.params.id
    if (categoryId) {
      await this.getCategoryData(categoryId)
    }
  },
  methods: {
    async getCategoryData(categoryId) {
      await api.get(`/category/${categoryId}`).then((response) => {
        this.category = response.data
      })
    },

    saveCategory() {
      if (!this.validateRequest()) return

      this.saveBtnDisabled = true
      const params = new URLSearchParams(this.category)
      this.category.id ? this.updateCategory(params) : this.addCategory(params)
    },

    addCategory(data) {
      api
        .post('/category/save', data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(() => {
          alertSuccess('Category added successfully')
          this.$router.push({ name: 'categories' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    updateCategory(data) {
      api
        .post(`/category/modify/${this.category.id}`, data)
        .then(() => {
          alertSuccess('Category updated successfully')
          this.$router.push({ name: 'categories' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    validateRequest() {
      let isValid = true
      this.errors = {}
      if (!this.category.categoryName) {
        this.errors.categoryName = 'Name field is required'
        isValid = false
      }
      return isValid
    },
  },
}
</script>

<template>
  <div>
    <Teleport to="#elePageTitle">
      {{ pagetitle }}
    </Teleport>
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-header d-flex align-items-center">
            <h4 class="card-title">{{ $route.params.id ? 'Edit Category' : 'Add New Category' }}</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="saveCategory()">
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="name-input" class="form-label">Name</label>
                  <input type="text" class="form-control" placeholder="Enter name" id="name-input" v-model="category.categoryName" />
                  <div v-if="errors.categoryName" class="invalid-feedback">{{ errors.categoryName }}</div>
                </div>
                <div class="col-12">
                  <label for="description-input" class="form-label">Description</label>
                  <textarea class="form-control" id="description-input" placeholder="Write description here" rows="3" v-model="category.categoryDescription"></textarea>
                  <div v-if="errors.categoryDescription" class="invalid-feedback">{{ errors.categoryDescription }}</div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-7">
                <router-link to="/categories" class="btn btn-light d-inline-flex align-items-center">
                  <i class="bx bx-arrow-back font-size-16 me-1"></i>
                  Back to List
                </router-link>
              </div>
              <div class="col-5 d-flex justify-content-end">
                <button class="btn btn-success d-flex align-items-center" @click.prevent="saveCategory()" :disabled="saveBtnDisabled">
                  <i v-if="!saveBtnDisabled" class="bx bx-check-double font-size-16"></i>
                  <i v-else class="bx bx-loader bx-spin font-size-16"></i>
                  <span class="ms-1">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
